import React from "react";
import { useTranslation } from "react-i18next";

export const AutInput = ({
  label,
  obligatorily,
  error,
  placeholder,
  value,
  onChange,
  onFocus,
  type = "text",
  disabled,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`w-full flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label className="text-xs font-semibold text-gray-700 flex items-center gap-1">
          {label}
          {obligatorily && <span className="text-red-500 font-bold">*</span>}
        </label>
      )}
      <input
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={onChange}
        onFocus={onFocus}
        className={`w-full px-3.5 py-2.5 min-h-[44px] rounded-xl text-sm transition-all outline-none bg-white placeholder-gray-400 ${
          disabled
            ? "opacity-50 cursor-not-allowed bg-gray-100 border border-gray-200"
            : error
            ? "border-2 border-red-500 bg-red-50/20 text-gray-900"
            : "border border-gray-200 hover:border-gray-300 focus:border-[#020637] focus:ring-2 focus:ring-[#020637]/10 text-gray-900 font-medium"
        }`}
      />
      {error && (
        <span className="text-[11px] text-red-500 font-medium">
          {typeof error === "string"
            ? error
            : t("profile.fieldRequired", "This field is required")}
        </span>
      )}
    </div>
  );
};
